import {ChartOptions} from "chart.js";

const ProgramKeyIndicatorOptions = () => {

    /**
     * Default options for key indicators charts.
     */
    const chartDefaultOptions = {
        responsive: true,
        maintainAspectRatio: false,
    };


    /**
     * Options for key indicators charts in preview mode.
     */
    const chartPreviewOptions: ChartOptions = {
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    padding: 4,
                    font: {
                        size: 9
                    },
                    boxWidth: 8
                }
            }
        }
    };

    /**
     * Options for key indicators charts in full screen mode.
     */
    const chartFullScreenOptions: ChartOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    padding: 10,
                    font: {
                        size: 12
                    },
                    boxWidth: 12
                }
            }
        }
    };

    return {
        chartDefaultOptions,
        chartPreviewOptions,
        chartFullScreenOptions
    };
};

export default ProgramKeyIndicatorOptions();
